import css from 'styled-jsx/css';
import { colors, icons, typography } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

export const alertIconSvg =
  '<?xml version="1.0" encoding="UTF-8"?><svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: sketchtool 51.3 (57544) - http://www.bohemiancoding.com/sketch --><title>CC94A0C3-EF13-4864-8070-1CD87B400E9C</title><desc>Created with sketchtool.</desc><defs><path d="M27,13.5 C34.425,13.5 40.5,19.575 40.5,27 C40.5,34.425 34.425,40.5 27,40.5 C19.575,40.5 13.5,34.425 13.5,27 C13.5,19.575 19.575,13.5 27,13.5 Z M26.9999996,15.3 C20.4749998,15.3 15.3,20.4749998 15.3,26.9999996 C15.3,33.5249994 20.4749998,38.6999992 26.9999996,38.6999992 C33.5249994,38.6999992 38.6999992,33.5249994 38.6999992,26.9999996 C38.6999992,20.4749998 33.5249994,15.3 26.9999996,15.3 Z M26.0999998,19.125 L27.8999998,19.125 L27.8999998,30.375 L26.0999998,30.375 L26.0999998,19.125 Z M27.0000003,35.0999992 C26.2544158,35.0999992 25.6500002,34.4955836 25.6500002,33.7499992 C25.6500002,33.0044148 26.2544158,32.3999991 27.0000003,32.3999991 C27.7455847,32.3999991 28.3500003,33.0044148 28.3500003,33.7499992 C28.3500003,34.4955836 27.7455847,35.0999992 27.0000003,35.0999992 Z" id="path-1"></path></defs><g id="CASOS-BUY-SECTION---1280px-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="PDPM-BS14-SoftCategory-AddToCartWhitoutSize-1" transform="translate(-19.000000, -19.000000)"><g id="POPUP" transform="translate(-1.000000, 0.000000)"><g id="icon/alert/alert" transform="translate(7.000000, 6.000000)"><mask id="mask-2" fill="white"><use xlink:href="#path-1"></use></mask><use id="Shape" fill="#BBBBBB" fill-rule="nonzero" xlink:href="#path-1"></use><g id="Color/Silver" mask="url(#mask-2)" fill="#FFC000" fill-rule="nonzero"><g transform="translate(-6.750000, -6.750000)" id="Amber"><rect x="0" y="0" width="67.5" height="67.5"></rect></g></g></g></g></g></g></svg>';

const deliveryAlertIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M11.75 11C11.34 11 11 11.34 11 11.75V16.75C11 17.16 11.34 17.5 11.75 17.5C12.16 17.5 12.5 17.16 12.5 16.75V11.75C12.5 11.34 12.16 11 11.75 11Z" fill="#333333"/>
  <path d="M11.75 2C6.36 2 2 6.36 2 11.75C2 17.14 6.36 21.5 11.75 21.5C17.14 21.5 21.5 17.14 21.5 11.75C21.5 6.36 17.14 2 11.75 2ZM11.75 20C7.19 20 3.5 16.31 3.5 11.75C3.5 7.19 7.19 3.5 11.75 3.5C16.31 3.5 20 7.19 20 11.75C20 16.31 16.31 20 11.75 20Z" fill="#333333"/>
  <path d="M11.75 7C11.2 7 10.75 7.45 10.75 8C10.75 8.55 11.2 9 11.75 9C12.3 9 12.75 8.55 12.75 8C12.75 7.45 12.3 7 11.75 7Z" fill="#333333"/>
</svg>`;
const SelectVariantStyles = css`
  .popup {
    height: calc(100vh - 180px);
    cursor: initial;
    background-color: ${colors.white.shade1};
    display: flex;
    flex-direction: column;
    @mixin tabletToDesktop {
      height: auto;
      width: 100%;
      min-height: 100%;
    }
    &.stockEnTienda {
      @mixin tabletToDesktop {
        width: 100%;
      }
      .body {
        @mixin mobileToTablet {
          padding: 0 17px;
        }
      }
    }
    &.deliveryOptions {
      @mixin tabletToDesktop {
        width: 100%;
        border-radius: 16px 0 0 16px;
      }
    }
    .variant-details.mkp {
      justify-content: space-between;
    }
  }
  button.close-button {
    background: none;
    &.hide {
      display: none;
    }
  }
  .store-availability-header {
    display: flex;
    button {
      position: absolute;
      top: 13px;
      right: 12px;
    }
    i.csicon-danger {
      color: ${colors.gray.shade29};
      font-size: ${typography.lg};
      @mixin tabletToDesktop {
        font-size: ${typography.sm};
      }
    }
  }
  .header {
    padding: 11px 20px 9.75px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colors.gray.shade14};
    @mixin tabletToDesktop {
      height: 50px;
      padding: 0 20px;
    }

    &.deliveryOptions {
      @mixin tabletToDesktop {
        height: 71px;
        border-bottom: none;
      }
      @mixin mobileToTablet {
        display: none;
      }
    }
    .csicon-icon-success-circle {
      color: ${colors.green.shade1};
      font-size: ${typography.xl3a};
    }

    .label {
      flex-grow: 1;
      margin: 0 14px;
      line-height: 24px;
      &.deliveryOptions {
        margin-left: 21.5px;
        @mixin mobileToTablet {
          margin: 0 0 0 16px;
          line-height: 26px;
        }
      }
    }

    .csicon-danger {
      color: ${colors.gray.shade29};
      font-size: ${typography.xs2};
      @mixin tabletToDesktop {
        font-size: ${typography.sm};
      }
    }

    .warning-icon {
      width: 55px;
      height: 27px;
      background-image: url('${svgToDataUri(alertIconSvg)}');
      background-size: contain;
      background-repeat: no-repeat;
      @mixin tabletToDesktop {
        width: 27px;
      }
    }

    .homeDelivery-icon {
      width: 32px;
      height: 32px;
      background-image: url('${svgToDataUri(icons.deliveryIconRebranded)}');
      background-size: contain;
      background-repeat: no-repeat;
    }

    .pickupInStore-icon {
      width: 32px;
      height: 32px;
      background-image: url('${svgToDataUri(icons.storeWithdrawalIconRebranded)}');
      background-size: contain;
      background-repeat: no-repeat;
      @mixin mobileToTablet {
        margin-bottom: 8px;
      }
    }
  }

  .body {
    overflow-x: hidden;
    padding: 0 27px;
    flex-grow: 1;

    @mixin tabletToDesktop {
      height: 426px;
    }

    .collections,
    .bundles {
      border-top: 1px solid ${colors.gray.shade14};

      span {
        margin: 22px 0;
        display: block;
      }
    }

    .collections {
      padding-top: 22px;
    }

    &.deliveryOptions {
      padding: 0 17px;
    }
  }

  .product-details {
    display: flex;
    border-bottom: 1px solid ${colors.gray.shade14};
    padding: 24px 0 18px;

    .product-image {
      box-sizing: border-box;
      height: 89px;
      width: 89px;
      border: 1px solid ${colors.gray.shade43};
      @mixin tabletToDesktop {
        height: 46px;
        width: 46px;
      }
    }
    .item-info {
      margin: 0;
      @mixin tabletToDesktop {
        width: 38%;
        margin: 0 0 0 18px;
      }
    }
    .info-wrapper {
      display: flex;
      width: 100%;
      flex-direction: column;
      margin-left: 18px;
      @mixin tabletToDesktop {
        flex-direction: row;
      }
    }

    &.deliveryOptions {
      @mixin tabletToDesktop {
        height: 82px;
        margin-bottom: 24px;
        border-bottom: none;
      }
      @mixin mobileToTablet {
        display: none;
      }
    }
  }

  .price {
    &.mt-8p {
      margin-top: 8px;
    }
    @mixin tabletToDesktop {
      margin-top: 0;
    }
  }

  .variant-details {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 72px);
    @mixin tabletToDesktop {
      flex-direction: row;
      height: auto;
    }

    .cual-buscas {
      margin-top: 24px;
      margin-bottom: 9px;
      color: #333;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;

      .warning-delivery-options-icon {
        width: var(--icon-size-icon-size, 24px);
        height: var(--icon-size-icon-size, 24px);
        min-width: 24px;
        max-width: 24px;
        min-height: 24px;
        max-height: 24px;
        background-image: url('${svgToDataUri(deliveryAlertIconSvg)}');
        background-size: contain;
        background-repeat: no-repeat;
        @mixin tabletToDesktop {
          width: 27px;
        }
      }
    }

    &.deliveryOptions {
      line-height: 15px;
      @mixin tabletToDesktop {
        flex-direction: column;
      }
    }
    .color-variants {
      width: 100%;
      margin-top: 20px;
      @mixin tabletToDesktop {
        width: 33%;
      }

      &.deliveryOptions {
        line-height: 15px;
        flex-direction: column;
        display: flex;
        @mixin tabletToDesktop {
          margin-bottom: 24px;
          justify-content: center;
          align-items: flex-start;
          gap: 0px;
          align-self: stretch;
          width: 100%;
        }
        @mixin mobileToTablet {
          max-height: 185px;
          overflow: auto;
          margin-bottom: 15px;
        }
      }
    }
    span.deliveryOptions-color {
      color: ${colors.gray.shade52};
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }

    .size-variants {
      width: 100%;
      margin: 0;
      @mixin tabletToDesktop {
        width: 33%;
        margin: 0 10px 0 28px;
      }
      &.deliveryOptions {
        @mixin tabletToDesktop {
          width: 100%;
          margin: 0;
        }
      }
      &.enhanced-size-selector {
        @mixin tabletToDesktop {
          width: 284px;
        }
      }
    }
    &.mkp {
      .size-variants,
      &.deliveryOptions {
        margin: 15px 0 0 0;
      }
    }
    .addToCart-container {
      width: 190px;
      background-color: ${colors.white.shade1};
      padding-top: 23px;

      &.mkp {
        width: 33%;
        display: flex;
        justify-content: flex-end;
        @mixin tabletToDesktop {
          width: auto;
        }
      }

      @mixin mobileToTablet {
        position: fixed;
        padding: 25px;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        &.mkp {
          font-size: ${typography.base};
          border-top: 1px solid #f0f0f0;
          height: 112px;
          width: 100%;
          padding: 0 24px 0 25px;
          justify-content: center;
          background-color: ${colors.gray.shade51};
        }
      }
    }
  }
  .stock-en-tienda-option-text {
    font-size: ${typography.xl};
    margin: 24px 0 10px 0;
    line-height: 21.6px;
  }
  .see-availability-container {
    display: flex;
    @mixin tabletToDesktop {
      justify-content: center;
      position: relative;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 72px;
      text-align: right;
      padding-top: 16px;
    }

    @mixin mobileToTablet {
      text-align: center;
      background-color: ${colors.white.shade1};
      box-shadow: 0 0 20px rgb(0 0 0 / 20%);
      justify-content: center;
      flex-direction: row;
      line-height: 18px;
      padding: 12px 0;
      position: fixed;
      bottom: 0;
      left: 0;
      width: -webkit-fill-available;
      display: flex;
    }

    .availability-btn-container {
      width: 207px;
      display: flex;
      align-items: center;
      @mixin tabletToDesktop {
        margin-left: 14px;
      }
    }
  }
`;

const closeButtonStyles = css`
  .cerrar-button {
    margin-bottom: 2px;
    &.float {
      margin-top: 13px;
      font-size: ${typography.base};
      @mixin tabletToDesktop {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding-right: 30px;
        height: 63px;
        margin-bottom: 0;
        background: ${colors.gray.shade41};
        text-align: right;
        border-top: 1px solid ${colors.gray.shade14};
      }
    }
    .cerrar-button-text {
      color: ${colors.black.shade1};
      font-size: 14px;
      letter-spacing: 0.19px;
      line-height: 17px;
      padding-bottom: 1px;
      text-decoration: underline;
      text-underline-position: under;
      margin-right: 14.5px;
      @mixin mobileToTablet {
        color: ${colors.black.shade9};
      }
    }
  }
`;

export { closeButtonStyles, SelectVariantStyles };
